import React from 'react';


// import animate on scroll
import Aos from 'aos';
import 'aos/dist/aos.css';

// import components
import Hero from './components/Hero';
import Aboutnabi from './components/Aboutnabi';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import Nabi from './components/Nabi';

const Kisahnabi = () => {
  // animate on scroll initialization
  Aos.init({
    duration: 1800,
    offset: 0,
  });
  return (
    <div className='overflow-hidden'>
      <Hero />
      <Aboutnabi />
      <Nabi />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Kisahnabi;
